import React from 'react';

import Thumb from '../img/works/bootstrap-landing-page.jpg';
import About from '../img/work-details/bootstrap-landing-page-about.jpg';
import Footer from '../img/work-details/bootstrap-landing-page-footer.jpg';

const BootstrapLandingPage = {
    id: 12, permalink: "bootstrap-landing-page", thumb: Thumb, title: "Bootstrap Landing Page", category: "Web Template", categoryURL: "webtemplate", detailImg1: About, detailImg2: Footer, previewTxt: "Preview", previewURL: "https://wasek23.github.io/bootstrap-landing-page/", sourceTxt: "", sourceURL: "", description: <>
        <h3 className="mbSmall">Bootstrap Landing Page is a Fully Responsive Bootstrap Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>Design With HTML5, CSS3 &amp; Bootstrap</li>
            <li>Google Web Fonts Included</li>
            <li>Fully Responsive Web Template</li>
            <li>Animated Gradient Header</li>
            <li>Gradient Header</li>
            <li>Smooth Scrolling With CSS</li>
            <li>Footer Weights</li>
        </ul>
    </>
};

export default BootstrapLandingPage;